// extracted by mini-css-extract-plugin
module.exports = {"container":"e_2B","title":"e_3B","subtitle":"e_4B","imageContainer":"e_5B"};